import React, { useState } from 'react'

import Success from '../Success'
import Confirm from '../Confirm'
import styles from '../../style.module.css'

function ConfirmMigration() {
    const [isMigrationSuccess, setIsMigrationSuccess] = useState(false)

    const onSuccess = () => setIsMigrationSuccess(true)

    let content = <Confirm onSuccess={onSuccess} />

    if (isMigrationSuccess) {
        content = <Success />
    }

    return (
        <div className={styles.modalWrap}>
            <div className={styles.modalView}>{content}</div>
        </div>
    )
}

export default ConfirmMigration
